module.exports = __webpack_public_path__ + "img/logo.e85655df.png";